import { render, staticRenderFns } from "./modalCrearCaja.vue?vue&type=template&id=4bd823cc&"
import script from "./modalCrearCaja.vue?vue&type=script&lang=js&"
export * from "./modalCrearCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports